"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectConnectExtension = void 0;
var helpers_1 = require("./helpers");
/**
 * Lightweight check for the Connect browser extension.
 * Does NOT launch Connect — only checks if the extension is installed.
 *
 * Chrome/Firefox/Edge: dispatches AsperaConnectCheck, listens for window message
 * Safari: dispatches AsperaConnectCheck, listens for document event
 */
var detectConnectExtension = function (timeoutMs) {
    return new Promise(function (resolve) {
        var resolved = false;
        var timer = setTimeout(function () {
            if (!resolved) {
                resolved = true;
                resolve(false);
            }
        }, timeoutMs);
        if ((0, helpers_1.isSafari)()) {
            var handler_1 = function () {
                if (!resolved) {
                    resolved = true;
                    clearTimeout(timer);
                    document.removeEventListener('AsperaConnectCheckResponse', handler_1);
                    resolve(true);
                }
            };
            document.addEventListener('AsperaConnectCheckResponse', handler_1);
        }
        else {
            var handler_2 = function (evt) {
                var _a;
                if (!resolved &&
                    typeof evt.data === 'object' &&
                    ((_a = evt.data) === null || _a === void 0 ? void 0 : _a.type) === 'AsperaConnectCheckResponse') {
                    resolved = true;
                    clearTimeout(timer);
                    window.removeEventListener('message', handler_2);
                    resolve(true);
                }
            };
            window.addEventListener('message', handler_2);
        }
        // Poll interval self-cleans via the resolved flag
        var poll = setInterval(function () {
            if (resolved) {
                clearInterval(poll);
                return;
            }
            document.dispatchEvent(new CustomEvent('AsperaConnectCheck'));
        }, 200);
        // Fire immediately
        document.dispatchEvent(new CustomEvent('AsperaConnectCheck'));
    });
};
exports.detectConnectExtension = detectConnectExtension;
